import React, { Component } from "react";
import IssueNoteImg from "../../assets/notes.png";
import { Button, Image } from "react-bootstrap";
import { ModalComponent } from "../reusableComponent/modal/index";
import { ModalTemplate } from "../reusableComponent/modalTemplate/index";
import htmlToFormattedText from "html-to-formatted-text";
import { saveIssueNote } from "../../services/apiServices";
import { getIssueNote } from "../../services/apiServices";
import request from "../../services/requestService";
import { LoaderPage } from "../../component/Loader";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { toast } from "react-toastify";
import { RedirectUser } from "../reusableComponent";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const toolbarConfig = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ header: "1" }, { header: "2" }],
    [{ size: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ]
  ]
};
const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video"
];
export class IssueNoteModal extends Component {
  state = {
    error: {},
    message: "",
    modalclose: false,
    isValueChange: false,
    textCount: 0,
    textCountMessage: "",
    modalOpen: false,
    isLoading: false,
    userId: "",
    userName: "",
    modifiedDate: "",
    editorHtml: "",
    theme: "snow"
  };
  handleChange(html, quill) {
    this.setState({ message: html });
  }
  handleOpenModal = async () => {
    this.setState({ modalOpen: true, isLoading: true });
    const { IssueId } = this.props;
    const response = await request(getIssueNote(IssueId));
    if (response.status == 200) {
      this.setState({
        isLoading: false,
        message: response.data.data.noteText,
        userId: response.data.data.userId,
        userName: response.data.data.userName,
        modifiedDate: response.data.data.modifiedDate
      });
    }
  };
  validateForm = async (fieldName, projectnotes) => {
    this.setState({ modalOpen: false, isLoading: true });
    const { isValueChange, textCount } = this.state;
    const { IssueId } = this.props;
    let { onSubmit, value } = this.props;
    if (isValueChange) {
      const response = await request(
        saveIssueNote({
          issueId: IssueId,
          note: ""
        })
      );
      this.setState({ isLoading: false });
      const { message, status } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
    } else if (projectnotes != "") {
      const response = await request(
        saveIssueNote({
          issueId: IssueId,
          note: projectnotes
        })
      );
      const { status } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
      this.setState({ isLoading: false });
    } else {
      const response = await request(
        saveIssueNote({
          issueId: IssueId,
          note: value
        })
      );
      const { status } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
      this.setState({ isLoading: false });
    }
  };
  render() {
    const {
      modalOpen,
      message,
      isLoading,
      userId,
      userName,
      modifiedDate
    } = this.state;
    return (
      <>
        {isLoading ? <LoaderPage loading={isLoading} /> : null}
        <span
          className="issue-note-button issue-note-btn"
          onClick={this.handleOpenModal}
        >
          {/* <Image
            src={IssueNoteImg}
            className="issue-note-img"
            onClick={this.handleOpenModal}
          /> */}
          <div className="note-icon" />
          Note
        </span>

        {modalOpen ? (
          <ModalComponent
            centered={true}
            onClose={() => {
              this.setState({ modalOpen: false });
            }}
            containerClass="nodal-officer-popup comment-modal-body note-modal projectnote-modal"
            isLoading={true}
            hideProgressbar={true}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    <h4>Issue Note</h4>
                    <div className="email_editor projectnote-editor">
                      <ReactQuill
                        onChange={(html, quill) =>
                          this.handleChange(html, quill)
                        }
                        value={message == null ? "" : message}
                        theme={this.state.theme}
                        modules={toolbarConfig}
                        formats={formats}
                        bounds={".app"}
                        placeholder={"Type your Note here..."}
                        ref={el => {
                          this.reactQuillRef = el;
                        }}
                      />
                      <div style={{ paddingTop: 3 }}>
                        <span className="remaining-char">
                          Remaining characters :{" "}
                          <span
                            className="remaining-char"
                            style={{
                              color:
                                2000 - htmlToFormattedText(message).length < 0
                                  ? "red"
                                  : "#848584"
                            }}
                          >
                            {2000 - htmlToFormattedText(message).length}
                          </span>
                        </span>
                        {modifiedDate == null ? (
                          <span
                            className="last-modified-text"
                            style={{ visibility: "hidden" }}
                          >
                            Last modified by
                          </span>
                        ) : (
                          <span className="last-modified-text">
                            Last modified by{" "}
                            <RedirectUser
                              title={userName}
                              id={userId}
                              projectnotecss={true}
                            />{" "}
                            On {modifiedDate}
                          </span>
                        )}
                      </div>
                    </div>
                  </>
                }
                onSubmit={() => {
                  this.validateForm("projectnote", this.state.message);
                }}
                onClose={() => {
                  this.setState({ modalOpen: false }, () => {
                    //onClose();
                  });
                }}
                onSubmitTitle="Add"
                submitDisable={
                  2000 - htmlToFormattedText(message).length < 0 ? true : false
                }
              />
            }
          />
        ) : null}
      </>
    );
  }
}
